import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const HORIZONTAL_SCROLL_CARDS_CONTENT = `
eventCards {
  ... on eventCard_Entry {
    id
    title
    description
    ${ IMAGE_DESKTOP }
    ${ IMAGE_MOBILE }
    ${ LINK_FIELD }
  }
}
`

export const HORIZONTAL_SCROLL_CARDS = `
...on horizontalScrollCards_Entry {
  id
  typeHandle
  anchorId

  headingAdvanced { html }
  ${ HORIZONTAL_SCROLL_CARDS_CONTENT }
}
`
